import logo from '../img/logo.svg'

function Footer() {  
    return (
      <div>
        <div className='footer-wrapper'>
          <div className='divider'>
            <span className='title'>
              Information
            </span>
            <div className='separator' />
            <span>
                <br />상호 : JMC Entertainment
                <br />대표 : 황노경
                <br />주소 : 서울특별시 강서구 공항대로 209
                <br />1015호 (마곡동, 지엠지엘스타)
                <br />사업자번호 : 277-81-02761
            </span>
          </div>
          <div className='divider'>
            <span className='title'>
              Business Hours
            </span>
            <div className='separator' />
            <span>
                <br />평일 : 10:00 am ~ 07:00 pm
                <br />점심시간 : 12:30 pm ~ 1:30 pm
                <br />토·일·공휴일 휴무
            </span>
          </div>
          <div className='divider'>
            <span className='title'>
              Contact Us
            </span>
            <div className='separator' />
            <span>
              <a target='_blank' rel='noopener noreferrer' href='mailto:jmcenter2022@gmail.com'>
                <br />E-mail : jmcenter2022@gmail.com
              </a>
            </span>
          </div>
        </div>
        <img
            className='logo pointer'
            src={ logo }
            onClick={() => { window.open('/', '_self') }}
            alt=''
        />
      </div>
    );
}

export default Footer;